import { useContext, useEffect, useState } from "react";
import { UserData } from "../../../Context/DataContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import styles from "./styles/inheritance.module.css";
import lawyer_image from "./styles/img/lawyer_image.svg";
import lawyer_icon from "./styles/img/laywer_icon.svg";
import EditNotaryPopup from "../EditNotaryPopup/EditNotaryPopup";

import PhoneInput from "react-phone-input-2";
import { formatUrl } from "../../../Utils/formatUrl";
export default function LegalData({ setModal }) {
  const userData = UserData();
  const legalData = userData?.UserData?.legal;

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [previewedLogo, setPreviewedLogo] = useState(undefined);

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const userValidationData = userData?.userValidationData;

  useEffect(() => {
    if (
      legalData[0]?.profile_avatar &&
      legalData[0]?.profile_avatar !== null &&
      legalData[0]?.profile_avatar !== undefined
    ) {
      let extension = legalData[0].profile_avatar[0];
      if (extension === "/") extension = ".jpg";
      else if (extension === "i") extension = ".png";

      const imageUrl = `data:image/${extension};base64,${legalData[0].profile_avatar}`;
      setPreviewedLogo(imageUrl);
    }
  }, [userValidationData?.legal_advisor_logo, legalData[0]?.profile_avatar]);
  return (
    <div className={styles.lawyerContainer}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            width: "70%",
          }}
        >
          {(legalData[0]?.type.toLowerCase() !== "wealth manager" ||
            legalData[0]?.type.toLowerCase() !== "notary" ||
            legalData[0]?.type.toLowerCase() !== "lawyer") && (
            <p style={{ fontSize: "12px", fontWeight: "500" }}>
              {legalData[0]?.type}
            </p>
          )}
          {legalData[0]?.type.toLowerCase() === "lawyer" && (
            <p style={{ fontSize: "12px", fontWeight: "500" }}>
              {dublicatedcontent.dublicatedText251}:
            </p>
          )}
          {legalData[0]?.type.toLowerCase() === "notary" && (
            <p style={{ fontSize: "12px", fontWeight: "500" }}>
              {dublicatedcontent.dublicatedText252}:
            </p>
          )}
          {legalData[0]?.type.toLowerCase() === "wealth manager" && (
            <p style={{ fontSize: "12px", fontWeight: "500" }}>
              {dublicatedcontent.dublicatedText250}:
            </p>
          )}
          <p className={styles.promotionContainerName}>{legalData[0]?.name}</p>
        </div>
        <div
          style={{
            borderRadius: "50%",
            alignSelf: "flex-start",
            position: "absolute",
            top: "20px",
            right: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={previewedLogo ? previewedLogo : lawyer_image}
            alt="lawyer"
            style={
              previewedLogo
                ? {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                  }
                : { width: "50px", height: "45px", borderRadius: "50%" }
            }
          />{" "}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
            width: "80%",
          }}
        >
          <img
            style={{
              scale: "1.2",
              marginBottom: "2px",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <p>{legalData[0]?.email}</p>
        </div>
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
          }}
        >
          <img
            style={{
              scale: "1.2",
              marginBottom: "2px",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <div className="overwrite_font">
            <PhoneInput
              inputClass={styles.legalPhoneInput}
              buttonClass={styles.legalHide}
              disableSearchIcon={true}
              value={legalData[0]?.phone_number}
            />
          </div>
          {/* <p>{legalData[0]?.phone_number}</p> */}
        </div>
        {legalData[0]?.address?.trim()?.length > 0 && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
                marginBottom: "2px",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <p>{legalData[0]?.address}</p>
          </div>
        )}{" "}
        {(legalData[0]?.website_url?.length > 0 ||
          userValidationData?.website_url?.length > 0) && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
                marginBottom: "2px",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <a
              rel="noreferrer"
              style={{
                cursor: "pointer",
                color: "var(--color_blue)",
                textDecoration: "underline",
                marginBottom: "2px",
              }}
              href={formatUrl(
                legalData[0]?.website_url
                  ? legalData[0]?.website_url
                  : userValidationData.website_url
              )}
              target="_blank"
              className={styles.promotionContainerTitle}
            >
              {legalData[0]?.website_url
                ? legalData[0]?.website_url
                : userValidationData.website_url}
            </a>
          </div>
        )}
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
          }}
        >
          <img
            style={{
              scale: "1.2",
              marginBottom: "2px",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <p
            style={{
              color: "var(--color_blue)",
              cursor: "pointer",
            }}
            onClick={() => {
              if (legalData.length > 0) {
                setModal(
                  <EditNotaryPopup
                    disabled={userData?.isFreezed}
                    onClose={() => setModal()}
                    toEdit={legalData[0]}
                  />
                );
              }
            }}
          >
            {dublicatedcontent?.dublicatedText253}
          </p>
        </div>
      </div>
    </div>
  );
}
